import type { CourseTypeId } from './courseTypes'
import type { CourseId } from './courses'
import type { CourseRoleId } from './courseRoles'
import type { ProgramId } from './programs'

export const courseGroupByType: Record<CourseTypeId, CourseId[]> = {
  m1: ['m1js', 'm1sql', 'm1py', 'm1blockchain'],
  fc: ['fcda', 'fcdm', 'fcse', 'fcuiux', 'fctm'],
  ca: ['cada', 'cabed', 'cafed', 'caba', 'capt'],
  'special-foundation': ['fif']
}

export const courseGroupByRole: Record<CourseRoleId, CourseId[]> = {
  SOFTWARE_ENGINEER: ['m1js', 'm1sql', 'm1py', 'm1blockchain', 'fcse', 'cafed', 'cabed'],
  DATA_SCIENCE: ['m1py', 'm1sql', 'fcda', 'cada', 'caba'],
  BUSINESS_MANAGEMENT: ['m1blockchain', 'fctm', 'caba'],
  DIGITAL_MARKETING: ['m1sql', 'fcdm'],
  CYBERSECURITY: ['m1sql', 'capt'],
  UXUI_DESIGNER: ['fcuiux'],
  PRODUCT_PROJECT_MANAGER: [],
  SALES_ACCOUNT_MANAGEMENT: [],
  CONSULTING_SYSTEM_INTEGRATION: [],
  IT_SUPPORT: [],
  NETWORKING_SYSTEM_ADMIN: [],
  GRAPHIC_DESIGN: [],
  MULTIMEDIA: [],
  TECHNICAL_WRITING: [],
  OTHERS: []
}

export const courseGroupByProgram: Record<ProgramId, CourseId[]> = {
  'yayasan-peneraju-2025': [
    'aws-ml-a',
    'aws-ml-s',
    'aws-csa-a',
    'aws-csa-p',
    'gc-a-ce',
    'gc-p-a',
    'gc-p-de',
    'gc-p-se'
  ],
  'kyouth-2025': ['cafed', 'cabed', 'cada', 'caba', 'fcdm', 'fcda', 'fcse', 'fif'],
  'kydp-2024': [],
  'kydp-2024-b': ['fcda', 'fcdm'],
  'moses-2023': [],
  'cap-2023': [],
  'ive-train-2023': [],
  dtfs: [],
  'google-career-2023': [],
  'kydp-2023': [],
  'mystep-2022': [],
  'google-career-2025': [
    'gcc-ud',
    'gcc-ada',
    'gcc-aie',
    'gcc-bi',
    'gcc-cs',
    'gcc-da',
    'gcc-dme',
    'gcc-ita',
    'gcc-its',
    'gcc-pm'
  ]
}

export const featuredCourses: CourseId[] = [
  'cada',
  'fcda',
  'fcdm',
  'fcse',
  'caba',
  'cabed',
  'cafed',
  'capt'
]
